"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.SurveyFormatGroupStatsToJSON = exports.SurveyFormatGroupStatsFromJSONTyped = exports.SurveyFormatGroupStatsFromJSON = exports.instanceOfSurveyFormatGroupStats = void 0;
var runtime_1 = require("../runtime");
var SurveyFormatType_1 = require("./SurveyFormatType");
var SurveyGroupStats_1 = require("./SurveyGroupStats");
/**
 * Check if a given object implements the SurveyFormatGroupStats interface.
 */
function instanceOfSurveyFormatGroupStats(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfSurveyFormatGroupStats = instanceOfSurveyFormatGroupStats;
function SurveyFormatGroupStatsFromJSON(json) {
    return SurveyFormatGroupStatsFromJSONTyped(json, false);
}
exports.SurveyFormatGroupStatsFromJSON = SurveyFormatGroupStatsFromJSON;
function SurveyFormatGroupStatsFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'formatRange': !(0, runtime_1.exists)(json, 'format_range') ? undefined : (0, SurveyFormatType_1.SurveyFormatTypeFromJSON)(json['format_range']),
        'stats': !(0, runtime_1.exists)(json, 'stats') ? undefined : (0, SurveyGroupStats_1.SurveyGroupStatsFromJSON)(json['stats']),
    };
}
exports.SurveyFormatGroupStatsFromJSONTyped = SurveyFormatGroupStatsFromJSONTyped;
function SurveyFormatGroupStatsToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'format_range': (0, SurveyFormatType_1.SurveyFormatTypeToJSON)(value.formatRange),
        'stats': (0, SurveyGroupStats_1.SurveyGroupStatsToJSON)(value.stats),
    };
}
exports.SurveyFormatGroupStatsToJSON = SurveyFormatGroupStatsToJSON;
